export default __webpack_public_path__ + "static/media/loving-logo.e638e5ce.svg";